import React from 'react';
import RecipeCards from './RecipeCards';
import { removeHTML } from '../../framework/utilities';

export default function UpcomingList({ taxonomyArticles, ads }) {
  const resultsRender = [];
  let index = 3;
  for (let article = 0; article < taxonomyArticles.length; article += 3) {
    resultsRender.push(
      <div key={article}>
        <section className="section section--lg u--background-color-white u--padding-top-0 u--padding-bottom-0">
          <div data-card-size="small" className="grid card__grid">
            {taxonomyArticles.slice(article, article + 3).map((article) => (
              <div key={article.id} className="grid__col-lg-4 grid__col-xs-12">
                <article
                  className={`card ${
                    article.sponsored ? 'card--sponsored' : ''
                  }`}
                >
                  <a href={article.url}>
                    <img
                      src={article.image ? article.image : ''}
                      className="card__media"
                      alt={removeHTML(article.title)}
                    />
                    <section className="card__body card__body--small">
                      <p className="card__category">{article.kicker}</p>
                      <h4
                        className="card__title"
                        dangerouslySetInnerHTML={{ __html: article.title }}
                      />
                      <p
                        className="card__description"
                        dangerouslySetInnerHTML={{ __html: article.subheader }}
                      />
                      {article.byline && (
                        <p className="card__byline">
                          {(article.byline_credit || 'By') + ' ' + article.byline}
                        </p>
                      )}
                    </section>
                  </a>
                  <hr className="card__hr" />
                </article>
              </div>
            ))}
          </div>
          <hr className="section__hr" />
        </section>
        {taxonomyArticles.length !== article + 3 &&
        (article + 3) / 6 == 1 &&
        ads[index] !== undefined ? (
          <section className="section section--lg u--padding-top-15 u--background-color-white">
            <div id={`gpt-ad-slot-square-2`} className="ad__container"></div>
          </section>
        ) : (
          ''
        )}
      </div>
    );
  }

  return <>{resultsRender}</>;
}
